/** @format */

export * from './product-image.component';
export * from './product-image.module';
